export default __webpack_public_path__ + "static/media/promotions.6e80b529.svg";